<category-component></category-component>

<div class="full-width-control d-block d-lg-none fixed-header-height-device">
    <!-- Sorting and filter for mobile and ipad -->
    <ul class="top-controls">
        <li>
            <product-sorting [filterReset]="isFilterReset"></product-sorting>
        </li>
        <li>
            <!-- <a class="cursor" [ngClass]="{'active-filter': filterSelected > 0? true: false}"
                (click)="sideBarComponent.openModal()">Filters<span
                    *ngIf="filterSelected > 0">({{filterSelected}})</span></a> -->

            <button class="filter-product" (click)="openAccordionFullscreen()">Filters</button>


        </li>
    </ul>
</div>


<div class="container-fluid product-lisitng-wrapper fixed-header-height">
    <div class="row">
        <div class="col-12 fixed-width-left-column all-product-col">
            <div class="button-box  tooltip-label">
                <button type="button" class="d-none d-lg-block toggle-sidebar-btn" (click)="toggleSideNav()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32">
                        <g fill="none" fill-rule="evenodd">
                            <g>
                                <g>
                                    <g fill="#2BA292">
                                        <path d="M0 0h14c8.837 0 16 7.163 16 16s-7.163 16-16 16H0V0z"
                                            transform="translate(-305.000000, -327.000000) translate(305.000000, 327.000000)" />
                                    </g>
                                    <g fill="#FFF" fill-rule="nonzero">
                                        <path d="M11 4L11.849 4.849 7.424 9.273 3 4.849 3.849 4 7.424 7.575z"
                                            transform="translate(-305.000000, -327.000000) translate(305.000000, 327.000000) translate(6.000000, 10.000000) translate(7.424264, 6.636396) scale(-1, 1) rotate(-90.000000) translate(-7.424264, -6.636396)" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32"
                        class="back-arrow">
                        <g fill="none" fill-rule="evenodd">
                            <g>
                                <g>
                                    <g fill="#D9394C">
                                        <path d="M0 0h14c8.837 0 16 7.163 16 16s-7.163 16-16 16H0V0z"
                                            transform="translate(0.000000, -327.000000) translate(0.000000, 327.000000)" />
                                    </g>
                                    <g fill="#FFF" fill-rule="nonzero">
                                        <path d="M11 4L11.849 4.849 7.424 9.273 3 4.849 3.849 4 7.424 7.575z"
                                            transform="translate(0.000000, -327.000000) translate(0.000000, 327.000000) translate(6.000000, 10.000000) translate(7.424264, 6.636396) rotate(-90.000000) translate(-7.424264, -6.636396)" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                </button>
                <div class="right">
                    <p>Hide Filters</p>
                    <p class="show-filters cursor">Show Filters</p>
                    <i></i>
                </div>
            </div>

            <div class="left-content-box new-filter">
                <div class="fullscreen-accordion d-block d-lg-none" *ngIf="isMobile" [class.show]="filterMobileview">
                    <button class="close-btn" (click)="filterMobileview = false">
                        <img src="../../assets/images/close-icon.svg" width="15" alt="close-icon" />
                    </button>

                    <app-sidebar-filters [pmpProduct]="pmpProduct" [promotionFilter]="promotionFilter"
                        [brandFilter]="brandFilter" [options]="options" [range]="range" [rspMin]="rspMinValue"
                        [rspMax]="rspMaxValue" (onViewAllBrands)="openModalbrands()"
                        (emitFiltersApplied)="onFiltersChangedHandler($event)"
                        (emitTagNamesApplied)="getAppliedTagsHandler($event)">
                    </app-sidebar-filters>

                </div>

                <div class="d-none d-lg-flex" *ngIf="!isMobile">
                    <app-sidebar-filters [pmpProduct]="pmpProduct" [promotionFilter]="promotionFilter"
                        [brandFilter]="brandFilter" [options]="options" [range]="range" [rspMin]="rspMinValue"
                        [rspMax]="rspMaxValue" (onViewAllBrands)="openModalbrands()"
                        (emitFiltersApplied)="onFiltersChangedHandler($event)"
                        (emitTagNamesApplied)="getAppliedTagsHandler($event)">
                    </app-sidebar-filters>
                </div>
            </div>
        </div>

        <div class="col-12  fixed-width-right-column all-product-col">
            <!-- Product listing HTML markup -->
            <ul class="breadcrumbs d-flex">
                <li>
                    <a routerLink="/" title="Home">Home</a>
                </li>
                <li>
                    <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
                </li>
                <li *ngIf="contentLoaded">
                    {{categoryName}}
                </li>
            </ul>
            <div class="heading-and-sort">
                <div>
                    <!-- For search -->
                    <div class="category-heading mb-0"
                        *ngIf="searchText !== '' && searchText !== null && searchText !== undefined && (categoryTitle =='' || categoryTitle == undefined)">
                        <h1>Showing results for '{{searchText}}'</h1>
                    </div>
                    <!-- For normal lsiting -->
                    <div class="category-heading mb-0"
                        *ngIf="searchText == '' || searchText == null || searchText == undefined">
                        <h1>{{categoryName}} <span>( {{totalProductCount}} products)</span></h1>
                    </div>
                </div>


                <div class="d-none d-lg-block">
                    <product-sorting [filterReset]="isFilterReset"></product-sorting>
                </div>
            </div>

            <div class="sort-div case-work-flow mt-3">
                <div class="btn-group" dropdown *ngIf="contentLoaded && categoryMessage.length > 0">
                    <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                        aria-controls="dropdown-basic">
                        <img src="../../assets/images/case-limit-icon.svg" alt="">
                        Case Limits <img src="../../assets/images/info-pink.svg" alt="">
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                        aria-labelledby="button-basic">
                        <li role="menuitem" *ngFor="let cat of categoryMessage"><a class="dropdown-item"
                                href="javascript:void(0)">{{cat}}
                            </a></li>

                    </ul>
                </div>
            </div>


            <div class="filter-select-tiles">
                <div class="tile categorytile" *ngIf="searchText != undefined && searchText != '' && categoryTitle != '' && categoryTitle !== undefined ">{{categoryTitle}} <img class="cursor"
                    src="../../assets/images/cancel.svg" alt="" (click)="onRemoveTitle()"> </div>
                <div class="tile" *ngIf="selectedPmpTag">{{selectedPmpTag}} <img class="cursor"
                        src="../../assets/images/tiles-close.svg" alt="" (click)="onRemovePmpFilter(0)"> </div>
                <div class="tile" *ngIf="selectedBrandTagName">{{selectedBrandTagName}} <img class="cursor"
                        src="../../assets/images/tiles-close.svg" alt="" (click)="onRemoveBrandFilter()"> </div>
                <div class="tile" *ngIf="selectedPromotionsTagName">{{selectedPromotionsTagName}} <img class="cursor"
                        src="../../assets/images/tiles-close.svg" alt="" (click)="onRemovePromotionsFilter('','')">
                </div>
            </div>

            <div class="product-grid of-product-listing" *ngIf="!noRecord" infiniteScroll [infiniteScrollDistance]="2"
                [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="true">

                <div class="product-wrapper product-page-listing" id="product_{{product.sku}}"
                    *ngFor="let product of productList">
                    <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li>
                            <img src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                    </ul>
                    <div class="product-inner-wrapper">
                        <div class="product-image">
                            <a href="javascript:void(0);" (click)="redirectTo(product.sku)">
                                <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                            </a>
                        </div>
                        <div class="product-description" id="product_description_{{product.sku}}">
                            <a href="javascript:void(0);" (click)="redirectTo(product.sku)"
                                class="product-detail-name-bar">
                                <h2>{{product.short_desc}} </h2>
                                <p>({{product.unit_size}})</p>
                            </a>
                            <ul class="product-code">
                                <li>{{product.barcode}}</li>
                                <li class="seperator">|</li>
                                <li>{{product.sku}}</li>
                            </ul>
                            <ul class="order-quantity-details">
                                <li>
                                    <span>RSP</span>
                                    <p> <span class="text-dark" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                                        <span class="text-dark" *ngIf="product.rsp == '0.00'">N/A</span>
                                        <span class="each"
                                            *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per
                                            100g</span>
                                        <span class="each"
                                            *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">each</span>
                                    </p>
                                </li>
                                <li *ngIf="global_data?.margin_visibility == 1">
                                    <span>Margin</span>
                                    <p><span class="text-dark">{{product.margin}}%</span></p>
                                </li>
                                <li *ngIf="global_data?.price_visibility == 1">
                                    <span>Cost</span>
                                    <p><strong>£{{product.price}}</strong></p>
                                </li>
                                <li>
                                    <span>Case</span>
                                    <p><strong>{{product.size_case}}</strong></p>
                                </li>

                            </ul>
                            <p *ngIf="product.back_in_stock == '0'" class="product-cart-status d-flex d-md-none"> <img
                                    src="../../assets/images/cross-round.svg" alt="checked icon" />Out of Stock</p>
                            <div class="add-cart-wrapper add_btn_{{product.product_id}}" ng-app="classApp"
                                [ngClass]="product.item_id !== '' ? 'expand' : 'no-expand'">
                                <div id="spinner_{{product.product_id}}">

                                    <ngx-number-spinner id="spinerbtn_{{product.product_id}}"
                                        *ngIf="product.item_id != ''"
                                        [ngClass]="{'spinner':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                                        [value]="toInteger(product.qty)" [min]="0"
                                        (change)="send(product, $event, commonTemplate)">
                                    </ngx-number-spinner>
                                </div>
                                <div class="right-column">

                                    <button
                                        [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                                        id="btn_{{product.product_id}}"
                                        *ngIf="product.item_id == '' && miniCartDetails.items_count != 0"
                                        (click)="addToCart(product, product.qty, '', 'common', commonTemplate,commonTemplateFor24HrPopup,true)">Add</button>
                                    <button
                                        [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                                        id="btn_{{product.product_id}}"
                                        *ngIf="product.item_id == '' && miniCartDetails.items_count == 0"
                                        (click)="addToCart(product, product.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,true)">Add</button>
                                    <p *ngIf="product.back_in_stock == '0'"
                                        class="product-cart-status d-none d-md-flex"> <img
                                            src="../../assets/images/cross-round.svg" alt="checked icon" />Out of Stock
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </div>

            <!-- No result found -->
            <div class="row no-result" *ngIf="contentLoaded && noRecord">
                <div class="col-12">
                    <div class="no-result-content">
                        <img src="../../assets/images/no-result.svg" alt="no-result">
                        <p>Sorry, no results found!</p>
                        <span>We couldn’t find what you’re looking for</span>
                    </div>
                </div>
            </div>

            <div class="row no-result" *ngIf="!contentLoaded && noRecord">
                <div class="col-12">
                    <div class="no-result-content">
                        <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
                        <p>Loading...</p>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<ng-template #addToCartTemplate>
    <div class="modal-header border-0 pb-2 align-items-center flex-column">
        <h4 class="modal-title">Info</h4>
        <p>You are about to create a order for</p>
        <h4 class="modal-title">{{selectedStore.selectedStoreName}}</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Please change the store if you want to create an order for another store.</p>
                </div>
                <div class="button-success text-center mt-3">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Ok</button>

                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commonTemplate>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>{{popupMessage}} </p>
                </div>
                <div class="button-div text-center mt-3 align-items-center">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">{{commonBottonText}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commonTemplateFor24HrPopup>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p style="white-space: pre-wrap">{{popupMessage}} </p>
                </div>
                <div class="button-div text-center mt-3 align-items-center">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
                    <button class="common-button mr-3"
                        (click)="addToCart(product_for_24_hr, product_for_24_hr.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,false)">{{commonBottonText}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- <ng-template #filtermobile>

    <app-sidebar-filters [pmpProduct]="pmpProduct" [promotionFilter]="promotionFilter" [brandFilter]="brandFilter"
        [options]="options" [range]="range" [rspMin]="rspMinValue" [rspMax]="rspMaxValue"
        (onViewAllBrands)="openModalbrands()" (emitFiltersApplied)="onFiltersChangedHandler($event)"
        (emitTagNamesApplied)="getAppliedTagsHandler($event)">
    </app-sidebar-filters>
</ng-template> -->